export const languageRulesKeys = {
  all: ['languageRules'] as const,
  list: (accountId: string) =>
    [...languageRulesKeys.all, 'list', accountId] as const,
}
